export class BranchServiceTypeFormModel {
  constructor(branchServiceType = {}) {
    this.id = branchServiceType.serviceTypeId || branchServiceType.id;
    this.mobility = branchServiceType.mobility || undefined;
    this.capacity = branchServiceType.capacity || "";
    // this.type = branchServiceType.type;
  }
}
